import React, { useCallback, useEffect, useState } from 'react';
import './CallCenter.css';
import SmsGonder from '../components/SmsGonder';
import { dosyaIndir, blobHatasiOku } from '../excel';
import { CALL, callYetkiVar } from '../yetki';
import {
  getCallCenterSecenekleri, getCallCenterListesi, getCallCenterDetay,
  callCenterGuncelle, callCenterOlustur, callCenterSil, callCenterAlanGuncelle,
  getCallCenterExcel,
} from '../services/api';

// Ekrandaki "Durumu" sütunu için kısa etiketler — uzun hâlleri sütunu şişirip tabloyu
// yatay kaydırmaya zorluyordu. Tam metin hücrenin title'ında duruyor (2026-09-03).
const DURUM_KISA = {
  0: 'Bekliyor',
  1: 'Ulaşılamadı → Tekrar',
  2: 'Ulaşılamıyor',
  3: 'Fake Numara',
  4: 'Netleşmedi → Tekrar',
  5: 'Olumsuz',
  6: 'Randevu Verildi',
  7: 'Whatsapp Bekleniyor',
  8: 'Etkinlik Arşivi',
};

// Call Center — VB6 CAGRILAR.frm ekranının karşılığı (kullanıcı talebi: 2026-09-03).
// Veri kaynağı CALLCENTER.BENIARA; şubeden bağımsızdır.

const iso = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const bugun = () => iso(new Date());
const gunOnce = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return iso(d); };
const suAn = () => {
  const d = new Date();
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

const trTarih = (v) => {
  if (!v) return '';
  const d = new Date(v);
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
};

// VB6'daki biçimlendirme: 05331644513 -> 0533 164 45 13, +491759880325 -> +49 175 988 0325
const telFormat = (ham) => {
  if (!ham) return '';
  const t = String(ham).replace(/\s/g, '');
  if (t.length === 11 && t.startsWith('05')) {
    return `${t.slice(0, 4)} ${t.slice(4, 7)} ${t.slice(7, 9)} ${t.slice(9)}`;
  }
  if (t.startsWith('+') && t.length > 10) {
    return `${t.slice(0, 3)} ${t.slice(3, 6)} ${t.slice(6, 9)} ${t.slice(9)}`;
  }
  return t;
};

// Cep telefonu için tıklanabilir tel: bağlantısı (Randevu Listesi ekranıyla aynı mantık).
const telLink = (ham) => {
  if (!ham) return null;
  const t = String(ham).trim();
  if (t.startsWith('+')) return t.replace(/[^\d+]/g, '');
  let r = t.replace(/\D/g, '');
  if (r.length === 12 && r.startsWith('90')) r = r.slice(2);
  else if (r.length === 11 && r.startsWith('0')) r = r.slice(1);
  return r.length === 10 ? `+90${r}` : null;
};

// SMS hangi numaraya gidecek (kullanıcı talebi: 2026-09-03):
//   Son Telefon (TEL2) doluysa ESAS ODUR — operatör numarayı düzeltmiş demektir.
//   Boşsa Telefon (TEL) kullanılır, o da biçimsel olarak geçerliyse.
//
// TEL2 dolu ama biçimi bozuksa TEL'e DÜŞÜLMEZ: operatörün bilerek değiştirdiği numara
// yerine eski numaraya SMS gitmesi yanlış kişiye ulaşmak demek olurdu.
const smsHedefi = (k) => {
  const son = (k.sonTelefon || '').trim();
  if (son) return { numara: telLink(son), ham: son, kaynak: 'Son Telefon' };
  const ilk = (k.telefon || '').trim();
  return { numara: telLink(ilk), ham: ilk, kaynak: 'Telefon' };
};

// anahtar = sunucunun döndürdüğü renk kodu (satır rengi ile aynı kaynak).
const LEJANT = [
  { anahtar: 'bekliyor', renk: '#A5DABB', ad: 'Aranmayı bekliyor' },
  { anahtar: 'tekrar', renk: '#ECF5BC', ad: 'Tekrar aranacak' },
  { anahtar: 'whatsapp', renk: '#C7D962', ad: 'Whatsapp cevap bekleniyor' },
  { anahtar: 'randevu', renk: '#FFFF80', ad: 'Randevu verildi' },
  { anahtar: 'pasif', renk: '#FFC0C0', ad: 'Pasif (ulaşılamıyor / fake / olumsuz)' },
  { anahtar: 'yok', renk: '#FFFFFF', ad: 'Diğer' },
];

// Basit pasta grafiği — dışarıdan grafik kütüphanesi eklemeden, inline SVG ile.
// (Kütüphane uygulama paketini kayda değer şekilde büyütürdü; burada tek bir dairelik
// iş var.) Dilim üzerine gelince ad ve adet ipucu olarak çıkar.
function Pasta({ dilimler, boyut = 132 }) {
  const toplam = dilimler.reduce((t, d) => t + d.adet, 0);
  if (toplam === 0) return null;

  const r = boyut / 2;
  const dolu = dilimler.filter(d => d.adet > 0);

  // Tek dilim %100 ise yay çizilemez (başlangıç ve bitiş aynı nokta) — tam daire çizilir.
  if (dolu.length === 1) {
    return (
      <svg width={boyut} height={boyut} role="img" aria-label={`${dolu[0].ad}: ${toplam}`}>
        <circle cx={r} cy={r} r={r - 1} fill={dolu[0].renk} stroke="rgba(0,0,0,.18)" />
        <title>{dolu[0].ad}: {toplam} (%100)</title>
      </svg>
    );
  }

  let aci = -Math.PI / 2;   // saat 12 yönünden başla
  const yollar = dolu.map(d => {
    const pay = d.adet / toplam;
    const bitis = aci + pay * 2 * Math.PI;
    const x1 = r + (r - 1) * Math.cos(aci), y1 = r + (r - 1) * Math.sin(aci);
    const x2 = r + (r - 1) * Math.cos(bitis), y2 = r + (r - 1) * Math.sin(bitis);
    const genisYay = pay > 0.5 ? 1 : 0;
    const yol = `M ${r} ${r} L ${x1} ${y1} A ${r - 1} ${r - 1} 0 ${genisYay} 1 ${x2} ${y2} Z`;
    aci = bitis;
    return { ...d, yol, yuzde: Math.round(pay * 100) };
  });

  return (
    <svg width={boyut} height={boyut} role="img" aria-label="Durum dağılımı">
      {yollar.map(y => (
        <path key={y.anahtar} d={y.yol} fill={y.renk} stroke="rgba(0,0,0,.18)" strokeWidth="1">
          <title>{y.ad}: {y.adet} (%{y.yuzde})</title>
        </path>
      ))}
    </svg>
  );
}

const ULASILDI_SONUC = [
  { kod: 'TEKRAR', ad: 'Bilgi aldı karar vermedi, TEKRAR ARANMALI' },
  { kod: 'OLUMSUZ', ad: 'Görüşüldü olumsuz oldu, tekrar aranmayacak' },
  { kod: 'RANDEVU', ad: 'Randevu verildi, tekrar aranmayacak' },
];

const ULASILAMADI_SONUC = [
  { kod: 'TEKRAR', ad: 'Ulaşılamadı, TEKRAR ARANMALI' },
  { kod: 'WHATSAPP_BEKLENIYOR', ad: '3 kez arandı, ulaşılamadı, whatsapp yazıldı, bekleniyor' },
  { kod: 'WHATSAPP_DONMEDI', ad: '3 arama + whatsapp yazıldı, dönmedi, tekrar aranmayacak' },
  { kod: 'FAKE', ad: 'Fake numara çıktı, tekrar aranmayacak' },
];

export default function CallCenter() {
  // Açılışta KRİTER görünümü seçili gelir (kullanıcı talebi: 2026-09-06). Filtreler
  // varsayılan tarih aralığıyla dolu olduğu için ekran boş açılmaz, ilk listeyi o verir.
  const [gorunum, setGorunum] = useState('kriter');
  const [baslangic, setBaslangic] = useState(gunOnce(10));
  const [bitis, setBitis] = useState(bugun());
  const [durum, setDurum] = useState('');
  const [telefon, setTelefon] = useState('');
  // Kutunun içi dolu gelir (bugün) ama filtreye ancak onay kutusu işaretliyse girer
  // (kullanıcı talebi: 2026-09-06 — VB6'daki "Tekrar Tar. ☐" davranışı).
  const [tekrarTarih, setTekrarTarih] = useState(bugun());
  const [tekrarTarihAktif, setTekrarTarihAktif] = useState(false);
  const [seciliKaynaklar, setSeciliKaynaklar] = useState([]);
  const [yeniUstte, setYeniUstte] = useState(true);

  const [secenekler, setSecenekler] = useState(null);
  const [kayitlar, setKayitlar] = useState([]);
  const [toplam, setToplam] = useState(0);
  const [kesildi, setKesildi] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');

  const [detay, setDetay] = useState(null);
  const [yeniAcik, setYeniAcik] = useState(false);
  const [silinecek, setSilinecek] = useState(null);
  const [smsHedef, setSmsHedef] = useState(null);
  // Seçili satır: notu alt şeritte gösterilir, alt şeritteki eylemler ona uygulanır.
  const [seciliId, setSeciliId] = useState(null);
  const secili = kayitlar.find(k => k.id === seciliId) || null;

  // Renk/durum dagilimi — EKRANDA GORUNEN kayitlar uzerinden (liste 1.000 satirda kesilir).
  // Hic kaydi olmayan durumlar lejantta gosterilmez, gereksiz yer kaplamasin.
  const dagilim = LEJANT
    .map(l => ({ ...l, adet: kayitlar.filter(k => k.renk === l.anahtar).length }))
    .filter(l => l.adet > 0);

  useEffect(() => {
    getCallCenterSecenekleri()
      .then(res => setSecenekler(res.data))
      .catch(() => setHata('Seçenek listeleri yüklenemedi.'));
  }, []);

  const listele = useCallback(async (e) => {
    if (e) e.preventDefault();
    setHata('');
    setYukleniyor(true);
    try {
      const params = { gorunum, yeniUstte };
      if (gorunum === 'kriter') {
        // İşaretli değilse tarih kutusu dolu olsa bile FİLTREYE GİRMEZ.
        if (tekrarTarihAktif && tekrarTarih) params.tekrarTarih = tekrarTarih;
        else { params.baslangic = baslangic; params.bitis = bitis; }
        if (durum !== '') params.durum = durum;
        if (telefon.trim()) params.telefon = telefon.trim();
        if (seciliKaynaklar.length) params.kaynaklar = seciliKaynaklar;
      }
      const res = await getCallCenterListesi(params);
      setKayitlar(res.data.kayitlar || []);
      setSeciliId(null);
      setToplam(res.data.toplam || 0);
      setKesildi(!!res.data.kesildi);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Çağrı listesi alınamadı.');
      setKayitlar([]); setToplam(0); setKesildi(false); setSeciliId(null);
    } finally {
      setYukleniyor(false);
    }
  }, [gorunum, baslangic, bitis, durum, telefon, tekrarTarih, tekrarTarihAktif, seciliKaynaklar, yeniUstte]);

  // Görünüm değişince otomatik listele (aktif/alarm zaten filtresizdir).
  useEffect(() => { listele(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [gorunum, yeniUstte]);

  const detayAc = async (id) => {
    setHata(''); setBilgi('');
    try {
      const res = await getCallCenterDetay(id);
      setDetay(res.data);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Kayıt detayı alınamadı.');
    }
  };

  const kaynakDegistir = (kod) =>
    setSeciliKaynaklar(s => s.includes(kod) ? s.filter(k => k !== kod) : [...s, kod]);

  // Biçimlendirilmiş .xlsx sunucuda üretiliyor; ekrandaki filtrelerin AYNISI gönderilir.
  // Ekranda 1.000 satır sınırı var ama dosyaya 20.000'e kadar kayıt girer.
  const [aktariliyor, setAktariliyor] = useState(false);

  const disaAktar = async () => {
    setHata(''); setBilgi('');
    setAktariliyor(true);
    try {
      const params = { gorunum, yeniUstte };
      if (gorunum === 'kriter') {
        // İşaretli değilse tarih kutusu dolu olsa bile FİLTREYE GİRMEZ.
        if (tekrarTarihAktif && tekrarTarih) params.tekrarTarih = tekrarTarih;
        else { params.baslangic = baslangic; params.bitis = bitis; }
        if (durum !== '') params.durum = durum;
        if (telefon.trim()) params.telefon = telefon.trim();
        if (seciliKaynaklar.length) params.kaynaklar = seciliKaynaklar;
      }
      dosyaIndir(await getCallCenterExcel(params), 'cagri-listesi.xlsx');
    } catch (err) {
      setHata((await blobHatasiOku(err)) || 'Excel dosyası oluşturulamadı.');
    } finally {
      setAktariliyor(false);
    }
  };

  const sil = async () => {
    try {
      await callCenterSil(silinecek.id);
      setBilgi(`"${silinecek.adSoy}" isimli çağrı kaydı silindi.`);
      setSilinecek(null);
      listele();
    } catch (err) {
      setHata(err.response?.data?.hata || 'Kayıt silinemedi.');
      setSilinecek(null);
    }
  };

  return (
    <div>
      {/* Kullanım ipucu başlıktan alınıp renk açıklamalarının sağına taşındı
          (kullanıcı talebi: 2026-09-04) — başlık tek satıra indi, liste yukarı çıktı. */}
      <div style={{ marginBottom: 12 }}>
        <h2 style={{ margin: 0, color: 'var(--med-dark)' }}>📞 Call Center</h2>
      </div>

      {bilgi && <div className="basari-kutu">{bilgi}</div>}
      {hata && <div className="hata-kutu">{hata}</div>}
      {kesildi && (
        <div className="hata-kutu" style={{ background: '#FAEEDA', color: '#633806' }}>
          {toplam.toLocaleString('tr-TR')} kayıt bulundu, ilk 1.000 tanesi gösteriliyor.
          Daha dar bir filtre kullanın.
        </div>
      )}

      {/* Solda dar filtre kolonu, sağda liste + alt şerit (kullanıcı talebi: 2026-09-03). */}
      <div className="cc-duzen">
      <div className="card cc-filtre">
        <div className="cc-gorunum" style={{ marginBottom: 12 }}>
          {[
            // Sıra kullanıcının çalışma sırası: önce kendi kriteri, sonra hazır görünümler.
            { kod: 'kriter', ad: 'Kriter ile ben seçeceğim', alt: null },
            { kod: 'aktif', ad: 'Aktif Çağrılar', alt: '( Bunlarla İlgilen )' },
            { kod: 'alarm', ad: 'Alarm Çağrılar', alt: '( Acil İlgilen )' },
          ].map(g => (
            <button
              key={g.kod}
              className={`cc-gorunum-btn cc-g-${g.kod}${gorunum === g.kod ? ' secili' : ''}`}
              aria-pressed={gorunum === g.kod}
              onClick={() => setGorunum(g.kod)}
            >
              {/* Seçim yalnızca onay işaretiyle belirtiliyor; renk sabit kalır ki
                  düğmeler birbirine karışmasın (kullanıcı talebi: 2026-09-03). */}
              <span className="cc-tik">{gorunum === g.kod ? '✔' : ''}</span>
              <span className="cc-g-yazi">
                <span className="cc-g-ad">{g.ad}</span>
                {g.alt && <span className="cc-g-alt">{g.alt}</span>}
              </span>
            </button>
          ))}

          {/* Sıralama seçimi görünüm düğmelerinin altında: listeyi değil FİLTREYİ
              ilgilendiren bir ayar, yeri burası (kullanıcı talebi: 2026-09-06). */}
          <label className="cc-yeniler-ustte">
            <input type="checkbox" checked={yeniUstte} onChange={e => setYeniUstte(e.target.checked)} />
            Yeniler üstte
          </label>
        </div>

        {gorunum === 'kriter' && (
          <form onSubmit={listele}>
            <div className="cc-alan">
              <label className="cc-etiket">Başlangıç</label>
              <input type="date" value={baslangic} onChange={e => setBaslangic(e.target.value)} disabled={tekrarTarihAktif} />
            </div>
            <div className="cc-alan">
              <label className="cc-etiket">Bitiş</label>
              <input type="date" value={bitis} onChange={e => setBitis(e.target.value)} disabled={tekrarTarihAktif} />
            </div>
            <div className="cc-alan">
              <label className="cc-etiket cc-etiket-onayli">
                <input type="checkbox" checked={tekrarTarihAktif}
                       onChange={e => setTekrarTarihAktif(e.target.checked)} />
                Tekrar Arama Tar.
              </label>
              <input type="date" value={tekrarTarih} onChange={e => setTekrarTarih(e.target.value)}
                     disabled={!tekrarTarihAktif}
                     title={tekrarTarihAktif ? '' : 'Filtreye girmesi için baştaki kutuyu işaretleyin'} />
            </div>
            <div className="cc-alan">
              <label className="cc-etiket">Durumu</label>
              <select value={durum} onChange={e => setDurum(e.target.value)}>
                <option value="">Tümü</option>
                {secenekler?.durumlar?.map(d => <option key={d.kod} value={d.kod}>{d.adi}</option>)}
              </select>
            </div>
            <div className="cc-alan">
              <label className="cc-etiket">Telefon No</label>
              <input type="text" value={telefon} onChange={e => setTelefon(e.target.value)} placeholder="Tümü" />
            </div>

            <div className="cc-alan">
              <label className="cc-etiket">Kaynak (boşsa tümü)</label>
              <div className="cc-kaynaklar">
                {secenekler?.kaynaklar?.map(k => (
                  <label key={k.kod}>
                    <input type="checkbox" checked={seciliKaynaklar.includes(k.kod)} onChange={() => kaynakDegistir(k.kod)} />
                    {k.adi}
                  </label>
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
              <button type="submit" className="btn btn-primary" disabled={yukleniyor} style={{ flex: 1 }}>
                {yukleniyor ? '...' : '🔎 Listele'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={() => {
                setBaslangic(gunOnce(10)); setBitis(bugun()); setDurum('');
                setTelefon(''); setTekrarTarih(bugun()); setTekrarTarihAktif(false);
                setSeciliKaynaklar([]);
              }}>Temizle</button>
            </div>
          </form>
        )}

        {/* Sıralama seçimi listenin üstüne, renk açıklamaları listenin altına taşındı
            (kullanıcı talebi: 2026-09-03) — bu kolonda yalnızca filtreler kalıyor. */}
      </div>

      <div className="cc-sag">
      {yukleniyor && <div className="loading">Yükleniyor...</div>}
      {!yukleniyor && kayitlar.length === 0 && <div className="empty">Bu filtrelerle çağrı kaydı bulunamadı.</div>}

      {!yukleniyor && kayitlar.length > 0 && (
        <>
          {/* Liste üstü sabit şerit: solda sayaç, sağda eylem düğmeleri. Düğmeler alt
              bilgi alanından buraya taşındı ki o alan kısalsın (kullanıcı talebi). */}
          <div className="cc-serit">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              {callYetkiVar(CALL.YENI_KAYIT) && (
                <button className="btn btn-primary" style={{ fontSize: 12, padding: '5px 11px' }}
                        onClick={() => { setBilgi(''); setYeniAcik(true); }}>
                  ➕ Yeni Kayıt
                </button>
              )}
              {callYetkiVar(CALL.EXCEL) && (
                <button className="btn cc-btn-excel"
                        onClick={disaAktar} disabled={aktariliyor}
                        title="Görünen listeyi biçimlendirilmiş Excel dosyası olarak indir">
                  {/* Emoji yerine çizim: emoji tarayıcıdan tarayıcıya değişiyor ve
                      "düğme" hissi vermiyordu (kullanıcı talebi: 2026-09-06). */}
                  <svg className="cc-excel-ikon" viewBox="0 0 16 16" aria-hidden="true">
                    <path d="M9.5 1H3.5A1.5 1.5 0 0 0 2 2.5v11A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V5.5L9.5 1z" />
                    <path className="cc-excel-kivrim" d="M9.5 1v3.2c0 .7.6 1.3 1.3 1.3H14" />
                    <path className="cc-excel-x" d="M5.6 7.6l4.8 5.2M10.4 7.6l-4.8 5.2" />
                  </svg>
                  {aktariliyor ? 'Hazırlanıyor...' : 'Excel'}
                </button>
              )}
            </div>
            {/* Renk açıklamaları ve kullanım ipucu listenin ALTINDAN buraya alındı
                (kullanıcı talebi: 2026-09-06): şeritte zaten boş duran alanı kullanıyorlar,
                altta kapladıkları kart kalktığı için liste uzadı. */}
            <div className="cc-serit-bilgi">
              {/* Kayıt sayısı grafiğin yanında duruyor (kullanıcı talebi: 2026-09-06). */}
              <span className="cc-sayac">{toplam.toLocaleString('tr-TR')} kayıt.</span>
              <div className="cc-lejant cc-lejant-satir">
                {dagilim.map(l => (
                  <span key={l.anahtar}>
                    <i className="cc-kutu" style={{ background: l.renk }} /> {l.ad}
                    <strong style={{ color: 'var(--med-dark)' }}>&nbsp;({l.adet})</strong>
                  </span>
                ))}
              </div>
              <span className="cc-ipucu">
                Satıra <strong>bir kez tıklayınca</strong> görüşme notu aşağıda açılır,
                satırın sonundaki <strong>AÇ</strong> düğmesiyle detay/güncelleme penceresi açılır.
              </span>
            </div>

            {/* Grafik listenin SAĞ ÜST köşesinde, akışın DIŞINDA (position:absolute) duruyor:
                başlık hizasındaki boş alanı kullandığı için hiç dikey yer harcamıyor, bu yüzden
                daha büyük çizilebiliyor (kullanıcı talebi: 2026-09-04). Dar ekranda akışa döner. */}
            <div className="cc-pasta"><Pasta dilimler={dagilim} boyut={92} /></div>
          </div>
          <div className="card cc-liste-kutu">
            <table className="cc-tablo">
              {/* Sabit genişlikler + tek satır + üç nokta: tablo her zaman ekrana sığar,
                  yatay kaydırma çubuğu çıkmaz. Sığmayan metin hücrenin title'ında görünür. */}
              <colgroup>
                <col style={{ width: '6%' }} /><col style={{ width: '3.5%' }} />
                <col style={{ width: '9.5%' }} /><col style={{ width: '7.5%' }} />
                <col style={{ width: '5%' }} />
                {/* Durumu bilerek geniş: kısa etiketler tek satıra sığsın, satırlar
                    alçak kalsın, listeye daha çok kayıt girsin (kullanıcı talebi). */}
                <col style={{ width: '9.5%' }} />
                <col style={{ width: '7%' }} /><col style={{ width: '4.5%' }} />
                <col style={{ width: '8.5%' }} /><col style={{ width: '4.5%' }} />
                <col style={{ width: '8.5%' }} /><col style={{ width: '5.5%' }} />
                {/* Ağrı bölgesi · Neden tekrar aranacak — sonuncusu eylem sütunundan
                    devredilen payla genişledi, artık üç noktayla kesilmiyor (2026-09-06). */}
                <col style={{ width: '4.5%' }} /><col style={{ width: '8%' }} />
                {/* Eylem sütunu: AÇ + SMS + Sil YAN YANA sığmalı. Daha dar olduğunda düğmeler
                    overflow:hidden yüzünden kırpılıp görünmez oluyordu (2026-09-03). Üç düğme
                    kenar boşluklarıyla ~110 px; %8.5 rahat yetiyor. */}
                <col style={{ width: '8.5%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th>Talep Tarihi</th><th>Saat</th><th>Adı Soyadı</th><th>Telefon</th><th>Son Telefon</th>
                  <th>Durumu</th><th>Nereden Ulaştı</th><th>Arandı</th><th>Aranma Zamanı</th>
                  <th>Ulaşıldı</th><th>Tekrar Arama</th><th>Şube</th><th>Ağrı Bölgesi</th>
                  <th>Neden Tekrar</th><th></th>
                </tr>
              </thead>
              <tbody>
                {kayitlar.map(k => {
                  const tel = telLink(k.telefon);
                  const sms = smsHedefi(k);
                  return (
                    <tr
                      key={k.id}
                      className={`cc-${k.renk}${k.id === seciliId ? ' cc-secili' : ''}`}
                      onClick={() => { setSeciliId(k.id); setBilgi(''); setHata(''); }}
                    >
                      <td>{trTarih(k.tarih)}</td>
                      <td>{k.saat}</td>
                      <td title={k.adSoy}>{k.adSoy}</td>
                      <td>
                        {tel
                          ? <a href={`tel:${tel}`} onClick={e => e.stopPropagation()} style={{ color: 'var(--med-dark)', fontWeight: 600 }}>{telFormat(k.telefon)}</a>
                          : telFormat(k.telefon)}
                      </td>
                      <td>{telFormat(k.sonTelefon)}</td>
                      <td title={k.durumAdi}>{DURUM_KISA[k.durum] ?? k.durumAdi}</td>
                      <td title={k.kaynak}>{k.kaynak}</td>
                      <td>{!k.arandi ? 'Hayır' : (k.durum === 8 ? '-' : `${k.kacKez} kez`)}</td>
                      <td>{k.arandi && k.aramaTarih ? `${trTarih(k.aramaTarih)} ${k.aramaSaat || ''}` : ''}</td>
                      <td>{k.arandi ? (k.ulasildi ? 'Evet' : 'Hayır') : ''}</td>
                      <td>{k.tekrarTarih ? `${trTarih(k.tekrarTarih)} ${k.tekrarSaat || ''}` : ''}</td>
                      <td title={k.subeTercihi}>{k.subeTercihi}</td>
                      <td title={k.agriBolgesi}>{k.agriBolgesi}</td>
                      <td title={k.nedenTekrar}>{k.nedenTekrar}</td>
                      {/* Satır içi kısayollar — alt şeritte de aynıları var; kullanıcı
                          satırdan doğrudan erişmeyi tercih ettiği için ikisi de duruyor. */}
                      <td className="cc-eylem" style={{ whiteSpace: 'nowrap' }}>
                        {/* Çift tıklama web'de keşfedilmiyor; aynı işi yapan açık bir düğme
                            de var (kullanıcı talebi: 2026-09-06). Çift tıklama KALDIRILMADI,
                            alışkanlığı olan kullanmaya devam edebilsin. */}
                        <button className="cc-ikon cc-ikon-ac" title="Kaydı aç — detay ve güncelleme"
                                onClick={e => { e.stopPropagation(); setSeciliId(k.id); detayAc(k.id); }}>
                          AÇ
                        </button>
                        {sms.numara && callYetkiVar(CALL.SMS_GONDER) && (
                          <button className="cc-ikon cc-ikon-sms"
                                  title={`SMS gönder — ${sms.kaynak}: ${telFormat(sms.ham)}`}
                                  onClick={e => {
                                    e.stopPropagation(); setSeciliId(k.id); setBilgi(''); setHata('');
                                    setSmsHedef({ ...k, smsNumara: sms.ham, smsKaynak: sms.kaynak });
                                  }}>
                            SMS
                          </button>
                        )}
                        {k.elleGiris && callYetkiVar(CALL.SIL) && (
                          <button className="cc-ikon cc-ikon-sil" title="Kaydı sil (yalnızca elle girilen kayıtlar)"
                                  onClick={e => { e.stopPropagation(); setSeciliId(k.id); setBilgi(''); setHata(''); setSilinecek(k); }}>
                            🗑
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

        </>
      )}

      {/* Alt şerit — VB6 ekranındaki gibi: solda büyük telefon, ortada görüşme notu,
          sağda seçili kayda uygulanan eylemler. Butonlar satırlardan buraya alındı ki
          tablo genişliği tamamen veriye kalsın (kullanıcı talebi: 2026-09-03). */}
      <div className="card cc-not">
        <div className="cc-not-baslik">
          <span>Görüşme Notu {secili ? `— ${secili.adSoy || '(isimsiz)'} · ${secili.durumAdi}` : ''}</span>
          {secili && <span style={{ fontWeight: 500, textTransform: 'none', letterSpacing: 0 }}>{trTarih(secili.tarih)} {secili.saat}</span>}
        </div>

        {/* Yalnızca telefon + not. Eylem düğmeleri buradan kaldırıldı: SMS/Sil satırın
            sonunda, Yeni Kayıt/Excel listenin üstünde — böylece bu alan alçak kalıyor. */}
        <div style={{ display: 'flex', alignItems: 'stretch' }}>
          <div style={{
            background: 'var(--med-dark)', color: '#fff', padding: '0 16px',
            display: 'flex', alignItems: 'center', flex: '0 0 auto',
          }}>
            {secili
              ? <span style={{ fontSize: 18, fontWeight: 800, letterSpacing: '.5px', whiteSpace: 'nowrap' }}>{telFormat(secili.telefon) || '—'}</span>
              : <span style={{ fontSize: 12.5, color: 'rgba(255,255,255,.6)', whiteSpace: 'nowrap' }}>Satır seçilmedi</span>}
          </div>

          <div className="cc-not-govde" style={{ flex: 1, minWidth: 0 }}>
            {!secili
              ? <span className="cc-not-bos">Notunu görmek istediğiniz satıra tıklayın.</span>
              : (secili.aciklama?.trim()
                  ? secili.aciklama
                  : <span className="cc-not-bos">Bu kayıt için görüşme notu girilmemiş.</span>)}
          </div>
        </div>
      </div>
      </div>
      </div>

      {detay && (
        <CagriDetay
          kayit={detay}
          secenekler={secenekler}
          kapat={() => setDetay(null)}
          kaydedildi={(mesaj) => { setDetay(null); setBilgi(mesaj); listele(); }}
          alanDegisti={() => listele()}
        />
      )}

      {yeniAcik && (
        <YeniCagri
          secenekler={secenekler}
          kapat={() => setYeniAcik(false)}
          kaydedildi={(mesaj) => { setYeniAcik(false); setBilgi(mesaj); listele(); }}
        />
      )}

      {smsHedef && (
        <SmsGonder
          numara={smsHedef.smsNumara}
          kaynak={smsHedef.smsKaynak}
          adSoy={smsHedef.adSoy}
          kapat={() => setSmsHedef(null)}
          gonderildi={(mesaj) => { setSmsHedef(null); setBilgi(mesaj); }}
        />
      )}

      {silinecek && (
        <div className="cc-modal-zemin" onClick={e => { if (e.target === e.currentTarget) setSilinecek(null); }}>
          <div className="cc-modal" style={{ maxWidth: 440 }}>
            <div className="cc-modal-baslik" style={{ background: '#A32D2D' }}>
              <strong>🗑 Çağrı Kaydını Sil</strong>
            </div>
            <div style={{ padding: 20 }}>
              <p style={{ fontSize: 13, lineHeight: 1.7, marginTop: 0 }}>
                <strong>{silinecek.adSoy}</strong> ({telFormat(silinecek.telefon)}) isimli çağrı kaydı silinsin mi?
                Bu işlem geri alınamaz.
              </p>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-danger" onClick={sil} style={{ flex: 1 }}>EVET, SİL</button>
                <button className="btn btn-secondary" onClick={() => setSilinecek(null)}>Vazgeç</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// --- Çağrı detay / güncelleme formu -------------------------------------------------

function CagriDetay({ kayit, secenekler, kapat, kaydedildi, alanDegisti }) {
  const [arandi, setArandi] = useState(kayit.arandi);
  const [aramaTarih, setAramaTarih] = useState(kayit.aramaTarih ? kayit.aramaTarih.slice(0, 10) : bugun());
  const [aramaSaat, setAramaSaat] = useState(kayit.aramaSaat && kayit.aramaSaat !== '__:__' ? kayit.aramaSaat : suAn());
  const [kacKez, setKacKez] = useState(kayit.kacKez || 0);
  const [ulasildi, setUlasildi] = useState(kayit.arandi ? kayit.ulasildi : null);
  const [sonuc, setSonuc] = useState(kayit.sonuc || '');
  const [tekrarTarih, setTekrarTarih] = useState(kayit.tekrarTarih ? kayit.tekrarTarih.slice(0, 10) : bugun());
  const [tekrarSaat, setTekrarSaat] = useState(kayit.tekrarSaat && kayit.tekrarSaat !== '__:__' ? kayit.tekrarSaat : '');
  const [nedenTekrar, setNedenTekrar] = useState(kayit.nedenTekrar || '');
  const [subeTercihi, setSubeTercihi] = useState(kayit.subeTercihi || '');
  const [agriBolgesi, setAgriBolgesi] = useState(kayit.agriBolgesi || '');
  const [aciklama, setAciklama] = useState(kayit.aciklama || '');

  const [ad, setAd] = useState(kayit.adSoy || '');
  const [tel, setTel] = useState(kayit.telefon || '');
  const [tel2, setTel2] = useState(kayit.sonTelefon || '');

  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [alanBilgi, setAlanBilgi] = useState('');

  const tekrarSecildi = sonuc === 'TEKRAR';
  // Tekrar arama tarihi resmi/dini tatile denk gelemez (kullanıcı talebi: 2026-09-04).
  // Liste RESMITATIL tablosundan geliyor; sunucu kaydederken de aynı kontrolü yapar.
  const tatilMi = tekrarSecildi && (secenekler?.tatiller || []).includes(tekrarTarih);
  const sonuclar = ulasildi ? ULASILDI_SONUC : ULASILAMADI_SONUC;

  // "Ulaşıldı" ile "Ulaşılamadı" seçenekleri farklı olduğundan, dal değişince seçim sıfırlanır.
  const dalDegistir = (yeni) => { setUlasildi(yeni); setSonuc(''); };

  const saatSonra = (saat) => {
    const d = new Date();
    d.setHours(d.getHours() + saat);
    setTekrarTarih(iso(d));
    setTekrarSaat(`${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`);
  };

  // Kaydedilen son değerler: Kaydet yalnızca GERÇEKTEN değişen alanları gönderir.
  const [kayitli, setKayitli] = useState({ ad: kayit.adSoy || '', telefon: kayit.telefon || '', sonTelefon: kayit.sonTelefon || '' });

  const alanKaydet = async (alan, deger) => {
    setHata(''); setAlanBilgi('');
    try {
      await callCenterAlanGuncelle(kayit.id, alan, deger);
      setKayitli(k => ({ ...k, [alan]: deger.trim() }));
      setAlanBilgi('Güncellendi.');
      // Liste arkada hemen yenilenir; pencere × ile kapatılsa da yeni numara görünür
      // (kullanıcı bildirimi: 2026-09-18, "güncel telefonlar kaydolmuyor").
      alanDegisti();
    } catch (err) {
      setHata(err.response?.data?.hata || 'Alan güncellenemedi.');
    }
  };

  const kaydet = async (e) => {
    e.preventDefault();
    setHata('');
    if (arandi && ulasildi === null) { setHata('Ulaşıldı mı, ulaşılamadı mı seçiniz.'); return; }
    if (arandi && !sonuc) { setHata('Çağrı sonucunu seçiniz.'); return; }
    if (arandi && tekrarSecildi && !tekrarSaat) { setHata('Lütfen tekrar arama saatini yazınız.'); return; }
    if (arandi && tatilMi) { setHata('Resmi ve Dini Tatillerde arama yapılamaz'); return; }

    // Ad / telefon kutularında değiştirilip 💾'ye basılmadan bırakılanlar da kaydedilir.
    // Önceden alttaki Kaydet bunları HİÇ göndermiyordu; kullanıcılar numarayı düzeltip
    // Kaydet'e basınca kaydolduğunu sanıyordu (kullanıcı bildirimi: 2026-09-18).
    const bekleyenAlanlar = callYetkiVar(CALL.ALAN_DUZELT)
      ? [['ad', ad], ['telefon', tel], ['sonTelefon', tel2]].filter(([a, d]) => d.trim() !== kayitli[a].trim())
      : [];

    setKaydediliyor(true);
    try {
      for (const [a, d] of bekleyenAlanlar) {
        try {
          await callCenterAlanGuncelle(kayit.id, a, d);
        } catch (err) {
          setHata(err.response?.data?.hata || 'Alan güncellenemedi.');
          return;
        }
      }
      await callCenterGuncelle(kayit.id, {
        arandi,
        aramaTarih: arandi ? aramaTarih : null,
        aramaSaat: arandi ? aramaSaat : null,
        kacKez: arandi ? Number(kacKez) : 0,
        ulasildi: arandi ? ulasildi : null,
        sonuc: arandi ? sonuc : null,
        tekrarTarih: arandi && tekrarSecildi ? tekrarTarih : null,
        tekrarSaat: arandi && tekrarSecildi ? tekrarSaat : null,
        nedenTekrar: arandi && tekrarSecildi ? nedenTekrar : null,
        subeTercihi: arandi && ulasildi ? subeTercihi : null,
        agriBolgesi: arandi && ulasildi ? agriBolgesi : null,
        aciklama,
      });
      kaydedildi(`"${kayit.adSoy}" çağrı kaydı güncellendi.`);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Çağrı bilgileri güncellenemedi.');
    } finally {
      setKaydediliyor(false);
    }
  };

  return (
    <div className="cc-modal-zemin" onClick={e => { if (e.target === e.currentTarget) kapat(); }}>
      <div className="cc-modal cc-modal-detay">
        <div className="cc-modal-baslik">
          <div>
            <strong>{kayit.adSoy}</strong>
            <small>{telFormat(kayit.telefon)} · {kayit.kaynak} · {trTarih(kayit.tarih)} {kayit.saat} · {kayit.durumAdi}</small>
          </div>
          <button onClick={kapat} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.85)', fontSize: 22, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>

        <form onSubmit={kaydet} style={{ padding: '14px 18px' }}>
          {/* Hızlı düzeltme alanları — VB6'daki küçük "ad / telefon / son telefon" panelleri. */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: 8, marginBottom: 10, paddingBottom: 10, borderBottom: '1px solid var(--border)' }}>
            {[
              { etiket: 'Adı Soyadı', deger: ad, ayarla: setAd, alan: 'ad' },
              { etiket: 'Telefon No', deger: tel, ayarla: setTel, alan: 'telefon' },
              { etiket: 'Son Telefon', deger: tel2, ayarla: setTel2, alan: 'sonTelefon' },
            ].map(a => (
              <div key={a.alan}>
                <label className="cc-etiket">{a.etiket}</label>
                <div style={{ display: 'flex', gap: 6 }}>
                  <input type="text" value={a.deger} onChange={e => a.ayarla(e.target.value)} style={{ minWidth: 0 }}
                         readOnly={!callYetkiVar(CALL.ALAN_DUZELT)} />
                  {callYetkiVar(CALL.ALAN_DUZELT) && (
                    <button type="button" className="btn btn-secondary" style={{ padding: '4px 9px' }}
                            title="Bu alanı güncelle" onClick={() => alanKaydet(a.alan, a.deger)}>💾</button>
                  )}
                </div>
              </div>
            ))}
          </div>
          {alanBilgi && <div className="basari-kutu">{alanBilgi}</div>}

          <div style={{ marginBottom: 10 }}>
            <label className="cc-etiket">Arandı mı?</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <button type="button" className={arandi ? 'btn btn-primary' : 'btn btn-secondary'} onClick={() => setArandi(true)}>EVET</button>
              <button type="button" className={!arandi ? 'btn btn-primary' : 'btn btn-secondary'} onClick={() => setArandi(false)}>HAYIR</button>
            </div>
            {!arandi && (
              <p style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 0 }}>
                "Hayır" ile kaydedilirse çağrıya ait tüm bilgiler (arama, sonuç, tekrar planı, açıklama) silinir
                ve kayıt "Aranmayı Bekliyor" durumuna döner.
              </p>
            )}
          </div>

          {/* İKİ KOLON (kullanıcı talebi: 2026-09-07): solda çağrı bilgileri, sağda
              açıklama. Açıklama sağ kolonun TAMAMINI kaplıyor — operatör uzun görüşme
              notunu 2 satırlık kutuya sığdırmaya çalışmıyor, pencere de uzamıyor. */}
          {arandi && (
            <div className="cc-detay-govde">
             <div className="cc-detay-sol">
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10, marginBottom: 10 }}>
                <div>
                  <label className="cc-etiket">Arama Tarihi</label>
                  <input type="date" value={aramaTarih} onChange={e => setAramaTarih(e.target.value)} required />
                </div>
                <div>
                  <label className="cc-etiket">Arama Saati</label>
                  <input type="time" value={aramaSaat} onChange={e => setAramaSaat(e.target.value)} required />
                </div>
                <div>
                  <label className="cc-etiket">Kaç Kez Arandı</label>
                  <select value={kacKez} onChange={e => setKacKez(e.target.value)}>
                    {[0, 1, 2, 3].map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                </div>
              </div>

              <div style={{ marginBottom: 10 }}>
                <label className="cc-etiket">Çağrı Başarısı</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button type="button" className={ulasildi === true ? 'btn btn-primary' : 'btn btn-secondary'} onClick={() => dalDegistir(true)}>ULAŞILDI</button>
                  <button type="button" className={ulasildi === false ? 'btn btn-primary' : 'btn btn-secondary'} onClick={() => dalDegistir(false)}>ULAŞILAMADI</button>
                </div>
              </div>

              {ulasildi !== null && (
                <div style={{ marginBottom: 10 }}>
                  <label className="cc-etiket">Çağrı Sonucu</label>
                  <div className="cc-secim">
                    {sonuclar.map(s => (
                      <label key={s.kod} className={sonuc === s.kod ? 'secili' : ''}>
                        <input type="radio" name="sonuc" checked={sonuc === s.kod} onChange={() => setSonuc(s.kod)} />
                        {s.ad}
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {tekrarSecildi && (
                <div style={{ background: 'var(--med-light)', borderRadius: 10, padding: 10, marginBottom: 10 }}>
                  <label className="cc-etiket">Tekrar Arama Planı</label>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10 }}>
                    <div>
                      <label className="cc-etiket">Tarih</label>
                      <input type="date" value={tekrarTarih} onChange={e => setTekrarTarih(e.target.value)} required
                             style={tatilMi ? { borderColor: '#A32D2D', background: '#FCEBEB' } : undefined} />
                    </div>
                    <div>
                      <label className="cc-etiket">Saat</label>
                      <input type="time" value={tekrarSaat} onChange={e => setTekrarSaat(e.target.value)} required />
                    </div>
                    <div>
                      <label className="cc-etiket">Neden Tekrar Aranacak</label>
                      <select value={nedenTekrar} onChange={e => setNedenTekrar(e.target.value)}>
                        <option value="">Seçiniz</option>
                        {secenekler?.tekrarNedenleri?.map(n => <option key={n} value={n}>{n}</option>)}
                      </select>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 12, color: 'var(--text-muted)', alignSelf: 'center' }}>Hızlı:</span>
                    {[1, 2, 3, 4, 5].map(s => (
                      <button key={s} type="button" className="btn btn-secondary" style={{ padding: '3px 9px', fontSize: 12 }}
                              onClick={() => saatSonra(s)}>{s} saat sonra</button>
                    ))}
                  </div>

                  {/* Tatil listesi RESMITATIL tablosundan gelir; sunucu kaydederken de kontrol eder. */}
                  {tatilMi && (
                    <div className="hata-kutu" style={{ marginTop: 10, marginBottom: 0 }}>
                      Resmi ve Dini Tatillerde arama yapılamaz
                    </div>
                  )}
                </div>
              )}

              {ulasildi === true && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: 10, marginBottom: 10 }}>
                  <div>
                    <label className="cc-etiket">Şube Tercihi</label>
                    <select value={subeTercihi} onChange={e => setSubeTercihi(e.target.value)}>
                      <option value="">Seçiniz</option>
                      {secenekler?.subeTercihleri?.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="cc-etiket">Ağrı Bölgesi</label>
                    <select value={agriBolgesi} onChange={e => setAgriBolgesi(e.target.value)}>
                      <option value="">Seçiniz</option>
                      {secenekler?.agriBolgeleri?.map(a => <option key={a} value={a}>{a}</option>)}
                    </select>
                  </div>
                </div>
              )}

             </div>

             <div className="cc-detay-sag">
              <label className="cc-etiket">Açıklama</label>
              <textarea className="cc-aciklama" value={aciklama}
                        onChange={e => setAciklama(e.target.value)}
                        placeholder="Görüşmede konuşulanları buraya yazın…" />
              <span className="cc-aciklama-sayac">{(aciklama || '').length} karakter</span>
             </div>
            </div>
          )}

          {hata && <div className="hata-kutu">{hata}</div>}

          <div style={{ display: 'flex', gap: 8 }}>
            {callYetkiVar(CALL.GUNCELLE) ? (
              <button type="submit" className="btn btn-primary" disabled={kaydediliyor || tatilMi} style={{ flex: 1 }}>
                {kaydediliyor ? 'KAYDEDİLİYOR...' : '💾 KAYDET'}
              </button>
            ) : (
              <span style={{ flex: 1, fontSize: 12, color: 'var(--text-muted)', alignSelf: 'center' }}>
                Çağrı sonucunu güncelleme yetkiniz yok — bilgiler salt okunur.
              </span>
            )}
            <button type="button" className="btn btn-secondary" onClick={kapat} disabled={kaydediliyor}>Kapat</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// --- Yeni çağrı kaydı ---------------------------------------------------------------

function YeniCagri({ secenekler, kapat, kaydedildi }) {
  const [tarih, setTarih] = useState(bugun());
  const [saat, setSaat] = useState(suAn());
  const [adSoy, setAdSoy] = useState('');
  const [tel, setTel] = useState('');
  const [kaynakKod, setKaynakKod] = useState(0);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');

  const kaydet = async (e) => {
    e.preventDefault();
    setHata('');
    if (!adSoy.trim()) { setHata('Adı soyadı zorunludur.'); return; }
    if (tel.trim().length < 11) { setHata('Telefon numarası EN AZ 11 basamaklı olmalıdır.'); return; }

    setKaydediliyor(true);
    try {
      await callCenterOlustur({ tarih, saat, adSoy: adSoy.trim(), tel: tel.trim(), kaynakKod: Number(kaynakKod) });
      kaydedildi(`"${adSoy.trim()}" çağrı kaydı oluşturuldu.`);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Çağrı kaydı oluşturulamadı.');
    } finally {
      setKaydediliyor(false);
    }
  };

  return (
    <div className="cc-modal-zemin" onClick={e => { if (e.target === e.currentTarget) kapat(); }}>
      <div className="cc-modal" style={{ maxWidth: 480 }}>
        <div className="cc-modal-baslik">
          <strong>➕ Yeni Çağrı Kaydı</strong>
          <button onClick={kapat} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.85)', fontSize: 22, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <form onSubmit={kaydet} style={{ padding: '14px 18px' }}>
          <div style={{ marginBottom: 10 }}>
            <label className="cc-etiket">Arama Tarih / Saat</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <input type="date" value={tarih} onChange={e => setTarih(e.target.value)} required style={{ flex: 1, minWidth: 0 }} />
              <input type="time" value={saat} onChange={e => setSaat(e.target.value)} required style={{ flex: '0 1 120px', minWidth: 0 }} />
              <button type="button" className="btn btn-secondary" style={{ padding: '0 10px' }}
                      title="Tarih ve saati şu ana ayarla"
                      onClick={() => { setTarih(bugun()); setSaat(suAn()); }}>⏱</button>
            </div>
          </div>

          <div style={{ marginBottom: 10 }}>
            <label className="cc-etiket">Adı Soyadı</label>
            <input type="text" value={adSoy} onChange={e => setAdSoy(e.target.value)} required />
          </div>

          <div style={{ marginBottom: 10 }}>
            <label className="cc-etiket">Telefon No</label>
            <input type="text" inputMode="tel" value={tel} onChange={e => setTel(e.target.value)}
                   placeholder="05XXXXXXXXX" required />
          </div>

          <div style={{ marginBottom: 18 }}>
            <label className="cc-etiket">Nereden Ulaştı</label>
            <select value={kaynakKod} onChange={e => setKaynakKod(e.target.value)}>
              {secenekler?.kaynaklar?.map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
            </select>
          </div>

          {hata && <div className="hata-kutu">{hata}</div>}

          <div style={{ display: 'flex', gap: 8 }}>
            <button type="submit" className="btn btn-primary" disabled={kaydediliyor} style={{ flex: 1 }}>
              {kaydediliyor ? 'KAYDEDİLİYOR...' : '👍 KAYDET'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={kapat} disabled={kaydediliyor}>Kapat</button>
          </div>
        </form>
      </div>
    </div>
  );
}
